<script setup>
import { computed } from 'vue'
import { t } from '@/locales'
import EmptyInbox from '/src/assets/svg/classroom/EmptyInbox.svg'
import EmptyInboxDark from '/src/assets/svg/classroom/EmptyInboxDark.svg'
import { useAppStore } from '@/store'

// const resolvedImageSrc = computed(() => {
//   return props.imageSrc || EmptyInboxIcon.value
// })

// Props
const props = defineProps({
  imageSrc: {
    type: String,
    default: '',
  },
  imageAlt: {
    type: String,
    default: 'empty',
  },
  imageClass: {
    type: String,
    default: 'w-52 h-auto',
  },
  message: {
    type: String,
    default: '',
  },
  useTranslation: {
    type: Boolean,
    default: true,
  },
  translationKey: {
    type: String,
    default: 'common.noData',
  },
})

const appStore = useAppStore()

const isDarkTheme = computed(() => appStore.theme === 'dark')

const EmptyInboxIcon = computed(() =>
  isDarkTheme.value ? EmptyInboxDark : EmptyInbox,
)

// Computed
const displayMessage = computed(() => {
  if (props.message)
    return props.message

  if (props.useTranslation)
    return t(props.translationKey)

  return 'No data available'
})
</script>

<template>
  <div class="py-1 bg-white dark:bg-[#18181c] rounded-lg ">
    <div class="flex flex-col items-center justify-center py-6">
      <img
        :src="EmptyInboxIcon"
        :alt="imageAlt"
        :class="imageClass"
        class="mb-0"
      >
      <slot>
        <div class="text-sm text-gray-500">
          <div class="text-sm text-gray-500">
            {{ displayMessage }}
          </div>
        </div>
      </slot>
    </div>
  </div>
</template>
